import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import LoginPage from "./LoginPage";         // Импортируем ваш новый логин
import ProductionPlanning from "./ProductionPlanning"; // Ваш компонент планирования

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      {isAuthenticated ? (
        <ProductionPlanning />
      ) : (
        <LoginPage onLogin={() => setIsAuthenticated(true)} />
      )}
    </>
  );
}
